/**
 * 鸿蒙平台JSSDK
 */
class OpenHarmony {
  constructor() {
    window._$zthm = {
      /**
       * 鸿蒙 event 广播事件列表
       */
      eventMaps: new Map(),

      /**
       * 鸿蒙 event 广播
       * @param {string} e
       */
      event: (name, e) => {
        switch (name) {
          /**
           * 鸿蒙 event 广播
           * @param {string} e
           */
          case 'frameEvent':
            try {
              const eventData = JSON.parse(e.data)
              const { name, data } = eventData
              console.log('鸿蒙 event 广播', name, data)
              const callback = window._$zthm.eventMaps.get(name)
              callback && callback(data)
            } catch (error) {
              console.error('鸿蒙 event 广播异常', error)
            }
            break
          /**
           * 鸿蒙 关闭窗口 广播
           * @param {string} e
           */
          case 'closeFrame':
            console.log('鸿蒙 event 广播 closeFrame', e)
            window._$zthm.eventMaps.get(`onFrameClose_${e.frameId}`) &&
              window._$zthm.eventMaps.get(`onFrameClose_${e.frameId}`)()
            break
        }
      }
    }
  }
  /**
   * 复制文本
   * @param {string} text
   */
  copyText(text) {
    return window.$zhm.copyText(text)
  }

  /**
   * 打开一个页面
   * @param {Object} data
   * @param {Function} callback
   */
  openFrame(data) {
    return new Promise((resolve, reject) => {
      const params = {
        url: data.url,
        title: data.title,
        titleColor: '#000',
        color: '#fff'
      }
      return window.$zhm.openFrame(JSON.stringify(params), (data) => {
        console.log('openFrameSuccess', data)
        resolve(data)
      })
    })
  }

  /**
   * 关闭一个frame窗口, 不传则关闭当前frame,传 0 则关闭所有frame,传 frameId 则页面栈关闭到指定frame
   * @param { string } id
   */
  closeFrame(id) {
    return window.$zhm.closeFrame(id)
  }

  /**
   * 发送消息
   * @param {string} name 消息名称
   * @param {Object} data 消息内容
   */
  postMessage(name, data) {
    window.$zhm.frameEvent(JSON.stringify({ name, data }))
  }
  /**
   * 接收消息
   * @param {string} name 消息名称
   * @param {Function} callback 回调函数，回调函数参数为消息内容
   */
  addEventListener(name, callback) {
    window._$zthm.eventMaps.set(name, callback)
  }
  /**
   * 移除消息监听
   * @param {string} name 消息名称
   */
  removeEventListener(name) {
    window._$zthm.eventMaps.delete(name)
  }

  /**
   * 关闭对应frameId页面时触发,只触发一次就会自动销毁
   * @param {string} id 页面id
   */
  addFrameCloseListener(id, callback) {
    window._$zthm.eventMaps.set(`onFrameClose_${id}`, () => {
      if (callback) {
        callback()
        window._$zthm.eventMaps.delete(`onFrameClose_${id}`)
      }
    })
  }
  /**
   * 移除关闭页面监听
   * @param {string} id 页面id
   */
  removeFrameCloseListener(id) {
    window._$zthm.eventMaps.delete(`onFrameClose_${id}`)
  }
  /**
   * 请求权限
   * @param {Array<string>} list 权限列表
   * @returns {Promise<boolean>} 是否成功
   */
  requestPermission(list) {
    return new Promise((resolve, reject) => {
      window.$zhm.requestPermission(list, (res) => {
        resolve(res)
      })
    })
  }
}

export default new OpenHarmony()
